import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewLocation from './new';
import EditLocation from './edit';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({location, refetch}) => {
  const [showAddLocationModal, setShowAddLocationModal] = useState(false);
  const [showEditLocationModal, setShowEditLocationModal] = useState(false);
  const loc = useLocation();
  return (
    <NavbarContainer>
      {getLinks()}
    </NavbarContainer>
  )

  function getLinks() {
    if(loc.pathname === '/locations') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddLocationModal(true)}
          >
            <Text>+ Add Location</Text>
          </Pressable>
          {showAddLocationModal &&
            <Modal
              showModal={showAddLocationModal}
              setShowModal={setShowAddLocationModal}
              modalType={'Add Location'}
              locationId={location?.id}
            >
              <NewLocation
                setShowModal={setShowAddLocationModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(loc.pathname === '/locations/new') {
      return (
        <Link to={`/locations`}>
          <Text>Locations</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <BoldLinkText>{location.name}</BoldLinkText>
          <LinkSpace />
          <Pressable
            onPress={() => {
              setShowEditLocationModal(true)
            }}
          >
            <Text>
              Edit
            </Text>
          </Pressable>
          {showEditLocationModal &&
            <Modal
              refetch={refetch}
              showModal={showEditLocationModal}
              setShowModal={setShowEditLocationModal}
              modalType={'Edit Location'}
              objectName={location.name}
            >
              <EditLocation
                setShowModal={setShowEditLocationModal}
                refetch={refetch}
                locationDetails={location}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
